module.exports = __webpack_public_path__ + "media/night/248-263a02ec.svg";